import {enumItems} from './enumItems';
import {SchemaWithClient} from '../types/SchemaWithClient';
import {Client} from '../services/Client';
import {NumberField} from '../components/Table/fields/NumberField';
import {TextField} from '../components/Table/fields/TextField';
import {SelectField} from '../components/Table/fields/SelectField';
import {DateField} from '../components/Table/fields/DateField';
import {CustomFieldForAccommodationPrices} from "../components/Table/fields/CustomFieldForAccommodationPrices";
import {SPDateField} from "../components/Table/fields/SPDateField";
import {SPNumberField} from "../components/Table/fields/SPNumberField";
import {SPSelectField} from "../components/Table/fields/SPSelectField";

export const accommodationPrice: SchemaWithClient<any> = {
  name: 'Accommodation Price',
  pluralName: 'Accommodation Price',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    }
  ],
  columns: {
    valid_from: {
      name: 'Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    accommodation_type: {
      name: 'Accommodation Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.accommodationType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.accommodationType),
      switchboard: true,
      url: enumItems.accommodationType.client.getAllPath,
      tempSchema: enumItems.accommodationType,
    },
    season_from: {
      name: 'Season From',
      fieldRenderer: DateField,
       slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    season_to: {
      name: 'Season To',
      fieldRenderer: DateField,
       slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    prices: {
      name: 'Prices',
      fieldRenderer: CustomFieldForAccommodationPrices,
      slidePaneFieldRenderer: CustomFieldForAccommodationPrices,
      fieldType: 'custom',
    },
    price_currency: {
      name: 'Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/accommodation-prices'),
};
